var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background-color":"#f2f4f7"}},[_c('Seo',{key:_vm.$route.path + 'seo'}),_c('div',[_c('router-view',{key:_vm.$route.path + 'router'})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }